import React, { createContext, useState } from "react";

const translations = {
  en: {
    welcomeMessagePart1: "All the investment skills you need",
    welcomeMessagePart2: "in one place",
    description: "Master the art of investing with expert-led courses.",
    exploreCourses: "Explore Courses",
    courses: "Courses",
    featuredCourses: "Featured Courses",
    personalDescription: "Your American dream starts with smart financial choices.",
    personalFinance:"Personal Finance",
    comingSoon: "Coming Soon!",
    riskRetirement: "Planning for Risk and Retirement",
    riskDescription: "Build the secure future you and your family deserve. In this course, you'll learn how to understand your risk profile, choose the right investments, and develop a strong financial mindset. ",
    financialAnalysis: "Financial Market Analysis",
    financialDescription: "Learn the fundamentals of finance that are essential for both investors and policymakers.",
    softwareIndustry: "Software Industry",
    softwareDescription: "Learn how to analyze data to improve investments performance with SoftwareIQ.",
    learnMore: "Learn More",
    getMore: "Get more from your money",
    getMoreDesc: "Gain confidence and control over everyday money decisions with our coaching program.",
    testimonials: "What learners are saying",
    testimonial1: " Invest DECODED helped me take control of my finances and make smarter investments! ",
    daniMartins: "- Daniela Martins",
    testimonial2: " Finally, I managed to quickly learn how to invest in the United States. ",
    lillian: "- Lillian Cabrini",
    tutoringTitle: "🚀 Why the Invest DECODED Tutoring & Coaching Program Stands Out?",
    tutoringDesc1: "Making financial decisions has never been more challenging. The market changes quickly, and often we don’t know the right next step. That’s where InvestDecoded comes in: our Tutoring & Coaching Program was created to empower you with knowledge, tools, and confidence to invest strategically.",
    tutoringDesc2: "Our experienced tutors and coaches help you understand complex financial concepts, develop practical strategies, and make smart decisions that grow your wealth and secure your future. Whether you are a beginner or an advanced investor, our program provides personalized guidance and valuable insights tailored to your profile.",
    tutoringFinal: "✨ Master Investing. Decode Success! ✨",
    contactUs: "Contact Us",
    financeLearn: "What you'll learn",
    financedescription: [
      "You will build a strong foundation in personal finance tailored for life in the United States.",
      "You will learn how to assess your financial goals, understand your risk tolerance, and make smart investment decisions.",
      "You will explore real-world investment tools like stocks, mutual funds, ETFs, and bonds.",
      "You will gain the skills to evaluate credit, improve your credit score, and understand how lenders make decisions.",
      "You will understand the role of insurance and how to protect yourself and your family from financial risks.",
      "You will create a retirement plan using tools like IRAs, pensions, and Social Security, so you can start planning early.",
      "You will learn how to recognize and avoid common financial mistakes that hurt many immigrant families.",
      "After this course, you’ll be empowered to make confident financial decisions and build long-term wealth in the U.S.",
      "You’ll be able to invest, save, and plan for your future — even if you’re starting from zero.",
      "You’ll gain financial independence and take control of your American dream."
    ],
    courseContent:"Course Content ",
    canAcess:"You can acess",
    acessmodule:"Module 0 - Introduction",
    forFree:"for free. Please",
    unlock: "to unlock the free course content.",
    loginfinance: "log in",
    premiumNote:"To access the full course and learn at your own pace. You’ll need a Premium Membership. 🔓",
    premiumNote2:"Upgrade to Premium and start your journey today!",
    whyPersonalFinance: "Why Study Personal Finance?",
    knowRiskLimit: "Know Your Risk Limit",
    investments: "Investments",
    waysInvest: "Ways to Invest",
    differentStockThinking: "Different Ways to Think About Stocks",
    buyingSellingStocks: "Buying and Selling Stocks",
    marketTimingExamples: "Examples of Market Timing",
    sellingStocks: "Selling Stocks",
    stocksHaveHomes1: "Stocks Have Homes - Part 1",
    stocksHaveHomes2: "Stocks Have Homes - Part 2",
    whereToFindStocks: "Where to Find Stocks to Buy",
    priceDiscovery: "Price Discovery and Market Fragmentation",
    mutualFunds: "Mutual Funds",
    vanguardGrowth: "Vanguard Dividend Growth",
    vanguard500: "Vanguard 500 Index",
    financialRatios: "Financial Ratios",
    etfs: "Exchange Traded Funds",
    stockIndices: "Stock Market Indices & Companies DJIA",
    stockAnalysis: "Stock Analysis",
    bonds: "Bonds",
    bondPricing: "Bond Pricing & Bond Rating",
    bondEarnings: "Bond Prices & How to Make Money Holding Bonds",
    stockInstruments: "Instruments to Buy or Sell Stocks",
    marginShortSelling: "Margin Buying & Short Selling",
    options1: "Options - Part 1",
    options2: "Options - Part 2",
    insuranceDefensiveStrategy: "Insurance Defensive Strategy",
    insuranceVsSpeculation: "The Difference Between Insurance and Speculation",
    oddsMakerUnderwriting: "The Odds Maker & Underwriting",
    insuranceEconomics: "Insurance Economics",
    termInsurance: "Term Insurance",
    universalLife: "Universal Life",
    needInsurance: "Do you need Insurance?",
    miscellaneousInsurance: "Miscellaneous Insurance",
    viaticalInsurance: "Viatical Insurance",
    propertyInsurance: "Property Insurance",
    homeownerInsurance: "Homeowner Insurance",
    automobileInsurance: "Automobile Insurance",
    autoInsuranceClaims:"Settling Auto Insurance Claims",
    autoInsurancePremiums: "Auto Insurance Premiums",
    decreasePremium: "Decrease Premium",
    intuitionInsuranceResearch: "Intuition Insurance Research",
    roleOfCredit: "Role of Credit",
    differentFacesOfCredit: "Different Faces of Credit",
    creditHouseholdDebtParadox: "Credit Household Debt Paradox",
    isAllCreditEqual: "Is all Credit Created Equal?",
    deadbeatsVsRevolvers: "Deadbeats vs Revolvers",
    whatLendersLookFor: "What Lenders Look For",
    creditBureaus: "Credit Bureaus",
    creditBureauInformation: "What do Credit Bureaus Do With Information?",
    ficoScore: "FICO Score",
    creditReportGuts: "Guts of a Credit Report",
    bankruptcy: "Bankruptcy",
    creditRationing: "Credit Rationing",
    startEarlyRetirement: "Start Early, Live Happy - Retirement",
    threeLeggedStool: "Three Legged Stool - Three sides to Retirement",
    socialSecurity: "Social Security",
    historyOfSocialSecurity: "History of Social Security",
    socialSecurityReserves: "Fight for the Social Security Reserves",
    pensions: "Pensions",
    definedContributions: "Benefits of Defined Contributions",
    chooseRetirementPlan: "Which Retirement Plan Should You Choose?",
    vesting: "Vesting",
    retirementBehaviorResearch: "Behavior Research in Retirement",
    lastLegRetirement: "The Last Leg of Retirement - Do it Yourself",
    rothIRA: "Roth IRA",
    traditionalVsRoth: "Traditional vs Roth",
    improvingRetirementSavingsBehavior: "Can People's Behavior in Retirement Savings be Improved?",
    module: "Module",
    introduction: "Introduction",
    fullAcess: "Full access is available only for premium users!",
    premiumTitle: "Full Access: Personal Finance Course",
    premiumPriceLabel: "Price:",
    premiumPrice: "$49.99",
    premiumPriceLabelPromo: "Black Friday Price:",
    promotionPrice: "$29.99",
    clickToReserve: "Click to reserve your spot",
    courseAvailabilityTitle: "About the Course:",
    courseAvailability: "New groups are opened every 3rd week of each month.",
    courseDurationTitle: "Course Duration:",
    courseDuration: "Learn at your own pace! You’ll have up to 4 months of platform access to the course, and at the end of the final module you can download the content.",
    needHelp: "Need Help?",
    supportMessage: "We're here to support you! Contact us via email or Instagram if you need help with:",
    courseAccessTitle: "Course Access:",
    courseAccessDesc: "Need more time or having trouble on the platform? Talk to us.",
    personalFinanceTitle: "Personal Finance:",
    personalFinanceDesc: "Get personalized guidance based on your goals.",
    mentorshipProgramsTitle: "Mentorship Programs:",
    mentorshipProgramsDesc: "Learn more about available sessions and how to join.",
    upgrademsg: " Upgrade to have Full Access to the Personal Finance Course",
    congrats: "Congratulations on completing the Personal Finance Course! You've unlocked all the modules and taken a big step toward financial empowerment.",
    premiumMemberMsg: "Become a premium member to unlock all modules and lessons in the Personal Finance Course.",
    conclusion: "Conclusion",
    paymentFailed: "Payment failed:",
    paymentSucceeded:"✅ Payment successful!",
    paymentUnexpected:"Unexpected payment status. Please contact support.",
    paymentError:"Error:",
    paymentDetails: "Payment Details",
    personalFinanceCourse: "Personal Finance Course",
    sigUp: "You're signing up for",
    personalClasses:"Personal Finance classes",
    team:"After your payment is confirmed, your access to the course is activated automatically. If you have any questions, contact us!",
    business: "investdecoded@investdecoded.com",
    after: "Thank you for choosing Invest Decoded! Enjoy the course. 🚀",
    fullName: "Full Name",
    email: "Email Address",
    cardNumber: "Card Number",
    expirationDateCVC: "Expiration Date & CVC",
    couponCode: "Coupon Code",
    couponApplied: "Coupon applied",
    priceLabel: "Price",
    totalLabel: "Total",
    payButton: "Pay",
    processingPayment: "Processing...",
    stockTradingBasicsTitle:"Stock Trading Basics",
    stockTradingIntro:"About the Course",
    basicTerminology:"Trading Accounts",
    orderTypes: "Market Terms",
    tradingStrategies:"Long & Short",
    riskManagementBasics:"Foundational Notes Every Trader Should Know",
    construction: "🚧 Course Under Construction!\nWe’re putting the finishing touches to offer you the best possible experience.\n✨ Check back soon for updates!",
    stockTradingDescription: "Lay the groundwork for successful trading with clear explanations of key concepts.",
    beyondBorders: "Trading Beyond Borders: U.S. vs. Global Markets",
    stockTradingLearn: [
      "You will learn how to open your first trading account and choose the type that fits your goals and capital.",
      "You will understand key stock market terms. ",
      "You will explore major indexes like the S&P 500 and how traders use them.",
      "You will compare trading platforms from beginner-friendly to advanced options.",
      "You will be introduced to options trading, risk management, and the mindset needed to succeed in volatile markets.",
      "After this course, you’ll be ready to place your first trade and continue building your skills with more advanced strategies.",],
    stockCourseContent: "The Stock Trading Basics course is completely free — all you need to do is sign up or log in. While it is primarily focused on the U.S. market, the content is not limited to the United States. In the final lesson, “Course Wrap-Up,” you’ll explore the key differences between U.S. and international markets and learn how to apply what you’ve learned in other countries.",
    lesson:"Lesson",
    previous:"Pevious",
    next:"Next",
    newsBannerText: "🎉 New course, Black Friday price: Investing in the U.S. for Brazilians – Complete Guide",
    newsBannerLink: "See Course",
    GuiasdeAjuda: "Help Guides",
    GuiaNãoEncontrado: "Guide Not Found",
    "categories.Getting Started in the U.S. Market": "Getting Started in the U.S. Market",
    "categories.Choosing What to Invest In": "Choosing What to Invest In",
    "categories.Understanding the Market": "Understanding the Market",
    "categories.Safety and Compliance": "Safety and Compliance",
    featuredGuides: "Help Guides",
    seeAllGuides: "See All Guides",
    downloadfree: "Learn at your own pace — download our free classes",
    download:"Learn at your own pace — download our classes",
    startCourse:"Start",
    downloadTitle:"50/30/20 Budget Spreadsheet",
    downloadSubtitle:"Download the editable spreadsheet to organize your budget into Needs (50%), Wants (30%), and Savings/Debt (20%).",
    InvestindonosEuaCourse: "Investing in the US for Brazilians – Complete Guide",
    investnoseuadescription2: "100% Portuguese-language course, focused on Brazilians who want to invest in the U.S. safely.",
    investnoseuadescription: `100% Portuguese-language course, focused on Brazilians who want to invest
in the U.S. safely: accounts (brokerage vs. retirement),
basic taxes, ETFs/REITs/bonds, portfolio construction,
and common pitfalls for immigrants.`,
    irparaocurso: "Go to the course",
    newcourse: "New course:",
  },

  pt: {
    welcomeMessagePart1: "Todas as habilidades de investimento que você precisa",
    welcomeMessagePart2: "em um só lugar",
    description: "Sua plataforma personalizada para aprender investimentos e crescer. Acompanhe seu progresso e desbloqueie novas habilidades hoje!",
    exploreCourses: "Explorar Cursos",
    courses: "Cursos",
    featuredCourses: "Cursos em Destaque",
    personalFinance:"Finanças Pessoais",
    personalDescription:"O seu sonho americano começa com escolhas financeiras inteligentes.",
    comingSoon: "Em Breve!",
    riskRetirement: "Planejamento para Risco e Aposentadoria",
    riskDescription: "Construa o futuro seguro que você e sua família merecem. Neste curso, você aprenderá a entender seu perfil de risco, escolher os investimentos certos e desenvolver uma mentalidade financeira forte.",
    financialAnalysis: "Análise do Mercado Finançeiro",
    financialDescription: "Aprenda os fundamentos das finanças essenciais para investidores e formuladores de políticas.",
    softwareIndustry: "Indústria de Software",
    softwareDescription: "Aprenda a analisar dados para melhorar o desempenho dos investimentos com o SoftwareIQ.",
    learnMore: "Saiba Mais",
    getMore: "Aproveite mais do seu dinheiro",
    getMoreDesc: "Ganhe confiança e controle sobre as decisões financeiras do dia a dia com nosso programa de coaching.",
    testimonials: "O que os alunos estão dizendo",
    testimonial1: "O Invest DECODED me ajudou a controlar minhas finanças e fazer investimentos mais inteligentes!",
    daniMartins: "- Daniela Martins",
    testimonial2: "Finalmente consegui aprender de maneira rapida como investir nos Estados Unidos",
    lillian: "- Lillian Cabrini",
    tutoringTitle: "🚀 Por que o Programa de Tutoria e Coaching da Invest DECODED é Diferente?",
    tutoringDesc1: "Tomar decisões financeiras nunca foi tão desafiador. O mercado muda rápido, e muitas vezes não sabemos qual o próximo passo. É aqui que a InvestDecoded entra: nosso Programa de Tutoria e Coaching foi criado para empoderar você com conhecimento, ferramentas e confiança para investir de forma estratégica.",
    tutoringDesc2: "Nossos tutores e coaches experientes ajudam você a entender conceitos financeiros complexos, desenvolver estratégias práticas e tomar decisões inteligentes que aumentam sua riqueza e garantem seu futuro. Seja você iniciante ou investidor avançado, nosso programa oferece orientação personalizada e insights valiosos adaptados ao seu perfil.",
    tutoringFinal: "✨ Domine os Investimentos. Decodifique o Sucesso! ✨",
    contactUs: "📩 Entre em Contato ",
    financeLearn: "O que você vai aprender",
    financedescription: ["Você vai construir uma base sólida em finanças pessoais, com foco na vida nos Estados Unidos.",
  "Vai aprender a definir seus objetivos financeiros, entender seu perfil de risco e tomar decisões inteligentes de investimento.",
  "Vai explorar ferramentas reais do mercado como ações, fundos mútuos, ETFs e títulos públicos e privados.",
  "Vai adquirir habilidades para entender o crédito, melhorar sua pontuação e compreender como os bancos tomam decisões.",
  "Vai aprender sobre seguros e como proteger você e sua família de riscos financeiros.",
  "Vai montar um plano de aposentadoria com opções como IRA, pensões e a Previdência Social americana — e entender por que começar cedo é essencial.",
  "Vai entender como evitar erros financeiros comuns que afetam muitas famílias imigrantes.",
  "Após o curso, você estará pronto para tomar decisões financeiras com confiança e construir riqueza nos EUA.",
  "Vai aprender a investir, poupar e planejar seu futuro — mesmo que esteja começando do zero.",
  "Você ganhará independência financeira e dará passos concretos rumo ao seu sonho americano."],
    courseContent: "Conteúdo do Curso",
    canAcess:"Você pode acessar o",
    acessmodule:"Módulo 0 – Introdução",
    forFree:"gratuitamente. Por favor,",
    unlock: "para desbloquear o conteúdo free do curso.",
    loginfinance: "faça o login",
    premiumNote:"Para acessar o curso completo e aprender no seu próprio ritmo, você precisará de uma Assinatura Premium. 🔓",
    premiumNote2:"Atualize para o Premium e comece sua jornada hoje mesmo!",
    whyPersonalFinance: "Por que estudar finanças pessoais?",
    knowRiskLimit: "Conheça seu limite de risco",
    investments: "Investimentos",
    waysInvest: "Maneiras de investir",
    differentStockThinking: "Diferentes maneiras de pensar sobre ações",
    buyingSellingStocks: "Comprar e vender ações",
    marketTimingExamples: "Exemplos de timing de mercado",
    sellingStocks: "Vendendo ações",
    stocksHaveHomes1: "As ações têm lares - Parte 1",
    stocksHaveHomes2: "As ações têm lares - Parte 2",
    whereToFindStocks: "Onde encontrar ações para comprar",
    priceDiscovery: "Descoberta de preços e fragmentação do mercado",
    mutualFunds: "Fundos mútuos",
    vanguardGrowth: "Crescimento de dividendos da Vanguard",
    vanguard500: "Índice Vanguard 500",
    financialRatios: "Índices Financeiros",
    etfs: "Fundos negociados em bolsa",
    stockIndices: "Índices do mercado de ações e empresas DJIA",
    stockAnalysis: "Análise de ações",
    bonds: "Títulos",
    bondPricing: "Precificação e classificação de títulos",
    bondEarnings: "Preços dos títulos e como ganhar dinheiro mantendo-os",
    stockInstruments: "Instrumentos para comprar ou vender ações",
    marginShortSelling: "Compra de margem e venda a descoberto",
    options1: "Opções - Parte 1",
    options2: "Opções - Parte 2",
    insuranceDefensiveStrategy: "Estratégia defensiva de seguros",
    insuranceVsSpeculation: "A diferença entre seguro e especulação",
    oddsMakerUnderwriting: "O avaliador de probabilidades e subscrição",
    insuranceEconomics: "Economia dos seguros",
    termInsurance: "Seguro de vida temporário",
    universalLife: "Seguro de vida universal",
    needInsurance: "Você precisa de seguro?",
    miscellaneousInsurance: "Seguros diversos",
    viaticalInsurance: "Seguro vitalício",
    propertyInsurance: "Seguro patrimonial",
    homeownerInsurance: "Seguro residencial",
    automobileInsurance: "Seguro automóvel",
    autoInsuranceClaims: "Liquidação de sinistros de seguro automóvel",
    autoInsurancePremiums: "Prêmios de seguro automóvel",
    decreasePremium: "Reduzir o prêmio do seguro",
    intuitionInsuranceResearch: "Pesquisa de intuição sobre seguros",
    roleOfCredit: "Papel do Crédito",
    differentFacesOfCredit: "Diferentes Faces do Crédito",
    creditHouseholdDebtParadox: "O Paradoxo da Dívida das Famílias",
    isAllCreditEqual: "Todo Crédito é Igual?",
    deadbeatsVsRevolvers: "Pagadores Pontuais vs Rotativos",
    whatLendersLookFor: "O Que os Credores Procuram",
    creditBureaus: "Órgãos de Crédito",
    creditBureauInformation: "O Que os Órgãos de Crédito Fazem com as Informações?",
    ficoScore: "Pontuação FICO",
    creditReportGuts: "Componentes de um Relatório de Crédito",
    bankruptcy: "Falência",
    creditRationing: "Racionamento de Crédito",
    startEarlyRetirement: "Comece Cedo, Viva Feliz - Aposentadoria",
    threeLeggedStool: "Banco de Três Pés - Três Lados da Aposentadoria",
    socialSecurity: "Segurança Social",
    historyOfSocialSecurity: "História da Segurança Social",
    socialSecurityReserves: "A Luta pelos Fundos da Segurança Social",
    pensions: "Pensões",
    definedContributions: "Benefícios das Contribuições Definidas",
    chooseRetirementPlan: "Qual Plano de Aposentadoria Escolher?",
    vesting: "Aquisição de Direitos",
    retirementBehaviorResearch: "Pesquisa Comportamental na Aposentadoria",
    lastLegRetirement: "A Última Etapa da Aposentadoria - Faça Você Mesmo",
    rothIRA: "Roth IRA",
    traditionalVsRoth: "Tradicional vs Roth",
    improvingRetirementSavingsBehavior: "O Comportamento na Poupança para Aposentadoria Pode Melhorar?",
    module: "Módulo",
    introduction: "Introdução",
    fullAcess: "O acesso completo está disponível apenas para usuários premium!",
    premiumTitle: "Acesso Completo: Curso de Finanças Pessoais",
    premiumPriceLabel: "Valor:",
    premiumPrice: "$ 49.99",
    premiumPriceLabelPromo: "Preço de Black Friday:",
    promotionPrice: "$29.99",
    clickToReserve: "Clique e garanta sua vaga",
    courseAvailabilityTitle: "Sobre o Curso:",
    courseAvailability: "Novas turmas são abertas toda 3ª semana de cada mês.",
    courseDurationTitle: "Duração do Curso:",
    courseDuration: "Estude no seu ritmo! Você tem até 4 meses de acesso ao curso pela plataforma e, ao final do último módulo, poderá baixar o conteúdo.",
    needHelp: "Precisa de Ajuda?",
    supportMessage: "Estamos aqui para te apoiar! Entre em contato por e-mail ou Instagram caso precise de ajuda com:",
    courseAccessTitle: "Acesso ao curso:",
    courseAccessDesc: "Precisa de mais tempo ou está com dificuldades na plataforma? Fale com a gente.",
    personalFinanceTitle: "Finanças pessoais:",
    personalFinanceDesc: "Receba orientação personalizada de acordo com seus objetivos.",
    mentorshipProgramsTitle: "Programas de mentoria:",
    mentorshipProgramsDesc: "Saiba mais sobre as sessões disponíveis e como participar.",
    upgrademsg: "Atualize para ter Acesso Completo ao Curso de Finanças Pessoais",
    congrats: "Parabéns por concluir o Curso de Finanças Pessoais! Você desbloqueou todos os módulos e deu um grande passo rumo à independência financeira.",
    premiumMemberMsg: "Torne-se um membro premium para desbloquear todos os módulos e lições do Curso de Finanças Pessoais.",
    conclusion: "Conclusão",
    paymentFailed: "Pagamento falhou:",
    paymentSucceeded: "✅ Pagamento aprovado!",
    paymentUnexpected: "Status de pagamento inesperado. Entre em contato com o suporte.",
    paymentError: "Erro:",
    paymentDetails: "Detalhes do Pagamento",
    personalFinanceCourse: "Curso de Finanças Pessoais",
    sigUp: "Você está se inscrevendo no curso de",
    personalClasses:"Finanças Pessoais",
    team:"Após a confirmação do pagamento, seu acesso às aulas é liberado automaticamente. Em caso de dúvidas, fale com a gente!",
    business: "investdecoded@investdecoded.com",
    after: "Obrigada(o) por confiar na Invest Decoded! Bons estudos. 🚀",
    fullName: "Nome Completo",
    email: "Endereço de E-mail",
    cardNumber: "Número do Cartão",
    expirationDateCVC: "Data de Validade e CVC",
    couponCode: "Código de Cupom",
    couponApplied: "Cupom aplicado",
    priceLabel: "Preço",
    totalLabel: "Total",
    payButton: "Pagar",
    processingPayment: "Processando...",
    stockTradingBasicsTitle: "Noções Básicas de Negociação de Ações",
    stockTradingIntro: "Sobre o Curso",
    basicTerminology: "Contas de Negociação",
    orderTypes: "Termos do Mercado",
    tradingStrategies: "Compra e Venda (Long & Short)",
    riskManagementBasics: "Conceitos Fundamentais que Todo Trader Deve Conhecer",
    construction: "🚧 Curso em Construção!\nEstamos finalizando os últimos detalhes para oferecer a melhor experiência possível.\n✨ Volte em breve para conferir as novidades!",
    stockTradingDescription: "Estabeleça as bases para negociações bem-sucedidas com explicações claras de conceitos essenciais.",
    beyondBorders: "Negociando Sem Fronteiras: EUA vs. Mercados Globais",
    stockTradingLearn: [
      "Você vai aprender como abrir sua primeira conta de investimento e escolher o tipo que se encaixa nos seus objetivos e no seu capital.",
      "Você vai entender os principais termos do mercado de ações.",
      "Você vai explorar os principais índices, como o S&P 500, e como os traders os utilizam.",
      "Você vai comparar plataformas de negociação — desde as mais simples para iniciantes até as mais avançadas.",
      "Você será introduzido ao mercado de opções, à gestão de risco e à mentalidade necessária para ter sucesso em mercados voláteis.",
      "Após este curso, você estará pronto para fazer sua primeira operação e continuar desenvolvendo suas habilidades com estratégias mais avançadas.",],
    stockCourseContent: "O curso Fundamentos da Bolsa de Valores é totalmente gratuito — basta se cadastrar ou fazer login para começar. Embora seja focado principalmente no mercado dos Estados Unidos, o conteúdo não se limita ao contexto norte-americano. Na aula final, “Encerramento do Curso”, você vai explorar as principais diferenças entre os mercados dos EUA e os internacionais, e aprender como aplicar o que aprendeu em outros países.",
    lesson: "Aula",
    previous:"Anterior",
    next:"Próximo",
    newsBannerText: "🎉 Novo curso, preço de Black Friday: Investindo nos EUA para Brasileiros – Manual Completo",
    newsBannerLink: "Ver Curso",
    GuiasdeAjuda: "Guias de Ajuda",
    GuiaNãoEncontrado: "Guia Não Encontrado",
    "categories.Getting Started in the U.S. Market": "Primeiros Passos no Mercado dos EUA",
    "categories.Choosing What to Invest In": "Como Escolher em que Investir",
    "categories.Understanding the Market": "Entendendo o Mercado",
    "categories.Safety and Compliance": "Segurança e Regulamentação",
    featuredGuides: "Guias de Ajuda",
    seeAllGuides: "Ver Todos os Guias",
    downloadfree: "Aprenda no seu ritmo — baixe nossas aulas grátis",
    download:"Aprenda no seu ritmo — baixe nossas aulas",
    startCourse:"Comecar",
    downloadTitle:"Planilha 50-30-20 %",
    downloadSubtitle:"Baixe a planilha editável para organizar seu orçamento por Necessidades (50%), Desejos (30%) e Poupança/Dívidas (20%).",
    InvestindonosEuaCourse: "Investindo nos EUA para Brasileiros – Manual Completo",
    investnoseuadescription2: "Curso 100% em português, focado em brasileiros que querem investir nos EUA com segurança.",
    investnoseuadescription: `Curso 100% em português, focado em brasileiros que querem investir
nos EUA com segurança: contas (brokerage x aposentadoria),
impostos básicos, ETFs/REITs/bonds, construção de portfólio e
armadilhas comuns para imigrantes.`,
    irparaocurso: "Ir para o curso",
    newcourse: "Novo curso:",
  },
};

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("pt"); // Default: English

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "pt" : "en"));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};
